// 林长任务相关接口
import request from '../utils/axios'

/**
 * @description:获取核查任务任务角色 (工作人员)
 * @return {int} -1:无权限 1:区管理 2：区执行人 3：乡镇管理 4：乡镇执行人,5:村管理：6村执行人
 */
export function GetVectorTaskPower() {
  return request({
    url: `/VectorTask/GetVectorTaskPower`,
    method: 'get',
  })
}

/**
 * @description: 获取核查任务模块管理区域乡镇名称下拉框(工作人员)
 * @param {int} type 1：查询人员 2：新增编辑人员 3：查询任务 4：发布/授权任务
 * @return {*}
 */
export async function GetAreaBox(type) {
  return await request({
    url: `/VectorTask/GetAreaBox?type=${type}`,
    method: 'get',
  })
}

/**
 * @description: 获取核查任务模块管理区域隶属关系下拉框(工作人员)
 * @param {int} type 1：查询人员 2：新增编辑人员 3：查询任务 4：发布/授权任务
 * @return {*}
 */
export async function GetAreaBox2(type) {
  return await request({
    url: `/VectorTask/GetAreaBox2?type=${type}`,
    method: 'get',
  })
}

/**
 * @description: 根据管理区域获取林长姓名下拉框(工作人员)
 * @param {*} params
 * @return {*}
 */
export function GetVectorTaskUserByArea(params) {
  return request({
    url: `/VectorTask/GetVectorTaskUserByArea`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取任务图层(工作人员)
 * @param {int} selectType 选择类型   0：我的创建 1：待分配  2：我的任务 3：待审核  4：经我审核  5：全部
 * @return {*}
 */
export function GetVectorTaskGeos(selectType) {
  return request({
    url: `/VectorTask/GetVectorTaskGeos?selectType=${selectType}`,
    method: 'get',
  })
}

/**
 * @description: 获取单个核查任务照片信息(工作人员)
 * @param {int} id
 * @return {*}
 */
export function GetGetVectorTaskImgInfo(id) {
  return request({
    url: `/VectorTask/GetGetVectorTaskImgInfo?id=${id}`,
    method: 'get',
  })
}

/**
 * @description: 添加核查任务人员(工作人员)
 * @param {*} params
 * @return {*}
 */
export function AddVectorTaskUser(params) {
  return request({
    url: `/VectorTask/AddVectorTaskUser`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取核查任务人员列表(工作人员)
 * @param {*} params
 * @return {*}
 */
export function GetVectorTaskUserLis(params) {
  return request({
    url: `/VectorTask/GetVectorTaskUserLis`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取核查任务人员详情接口(工作人员)
 * @param {long} id
 * @return {*}
 */
export async function GetVectorTaskUserDetails(id) {
  return await request({
    url: `/VectorTask/GetVectorTaskUserDetails?id=${id}`,
    method: 'get',
  })
}

/**
 * @description: 修改核查任务人员(工作人员)
 * @param {*} params
 * @return {*}
 */
export function UpdateVectorTaskUser(params) {
  return request({
    url: `/VectorTask/UpdateVectorTaskUser`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 删除核查任务人员(工作人员)
 * @param {long} id
 * @return {*}
 */
export function DeleteVectorTaskUser(id) {
  return request({
    url: `/VectorTask/DeleteVectorTaskUser?id=${id}`,
    method: 'get',
  })
}

/**
 * @description: 获取核查任务列表(工作人员)
 * @param {*} params
 * @return {*}
 */
export function GetVectorTaskLis(params) {
  return request({
    url: `/VectorTask/GetVectorTaskLis`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取核查任务详情(工作人员)
 * @param {long} id
 * @return {*}
 */
export function GetVectorTaskById(id) {
  return request({
    url: `/VectorTask/GetVectorTaskById?id=${id}`,
    method: 'get',
  })
}

/**
 * @description: 授权/发布核查任务(工作人员)
 * @param {*} params
 * @return {*}
 */
export function AuthorizerTask(params) {
  return request({
    url: `/VectorTask/AuthorizerVectorTask`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 删除核查任务(工作人员)
 * @param {long} id
 * @return {*}
 */
export function DeleteVectorTask(id) {
  return request({
    url: `/VectorTask/DeleteVectorTask?id=${id}`,
    method: 'get',
  })
}

/**
 * @description: 审核核查任务(工作人员)
 * @param {*} params
 * @return {*}
 */
export function ExamineVectorTask(params) {
  return request({
    url: `/VectorTask/ExamineVectorTask`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 导出核查任务shp文件(工作人员)
 * @param {*} params
 * @return {*}
 */
export function DownVectorTaskShpZip(params) {
  return request({
    url: `/VectorTask/DownVectorTaskShpZip`,
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

/**
 * @description: 获取核查任务固定统计数量(工作人员)
 * @param {*} params
 * @return {*}
 */
export function GetVectorTaskCount(params) {
  return request({
    url: `/VectorTask/GetVectorTaskCount`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取核查任务固定统计数量(工作人员)
 * @param {*} params
 * @return {*}
 */
export function GetVectorTaskCountByTime(params) {
  return request({
    url: `/VectorTask/GetVectorTaskCountByTime`,
    method: 'post',
    data: params,
  })
}
